module.exports = __webpack_public_path__ + "img/spicy-chicken-with-sesame-noodles.a5d03fc3.jpg";